module.exports = __webpack_public_path__ + "static/media/Screenshot2.396ab1a4.png";